import { Linear, Sine, TimelineMax, TweenMax } from 'gsap';
import { getGameSize } from '../../Config/Levels';
import { waitForMs } from '../../Utils/AsyncUtils';
import { getRandomFloat } from '../../Utils/Utils';

export class FallingParticle extends PIXI.Container {
    protected readonly particleCount: number;
    protected getParticle: () => PIXI.DisplayObject;
    protected readonly durationRange: number[];
    protected readonly rotate: boolean;

    constructor(
        getParticle: () => PIXI.DisplayObject,
        autoStart: boolean = true,
        particleCount: number = 100,
        durationRange = [2, 5],
        rotate: boolean = true
    ) {
        super();
        this.getParticle = getParticle;
        this.y = -getGameSize().gameHeight * 0.5;
        this.particleCount = particleCount;
        this.durationRange = durationRange;
        this.rotate = rotate;
        if (autoStart) {
            this.createFallingParticles().catch(err => {
                console.log(['error creating falling particle', err]);
            });
        }
    }

    public cleanUp() {
        TweenMax.killTweensOf(this);
        this.destroy();
    }

    public async createFallingParticles() {
        for (let i = 0; i < this.particleCount; i++) {
            const rect = this.getParticle();
            rect.cacheAsBitmap = true;
            rect.x = getRandomFloat(0, getGameSize().gameWidth);
            this.addChild(rect);
            this.animateParticle(rect);
        }
        await waitForMs(this.durationRange[1] * 1000 + 100);
        this.cleanUp();
    }

    private animateParticle(rect: PIXI.DisplayObject) {
        const timeline = new TimelineMax();
        const randomDuration = getRandomFloat(this.durationRange[0], this.durationRange[1]);
        timeline.to(rect, randomDuration, {
            y: getGameSize().gameHeight * 1.7,
            ease: Linear.easeNone,
        });
        timeline.to(
            rect,
            randomDuration,
            { x: rect.x + 70, repeat: -1, yoyo: true, ease: Sine.easeInOut },
            '-=' + randomDuration
        );
        if (this.rotate) {
            timeline.to(
                rect,
                randomDuration,
                {
                    scaleX: 0.2,
                    rotation: getRandomFloat(0, 10),
                    repeat: -1,
                    yoyo: true,
                    ease: Sine.easeInOut,
                },
                '-=' + randomDuration
            );
        }
        timeline.to(
            rect,
            randomDuration,
            { opacity: 0, repeat: -1, yoyo: true, ease: Sine.easeInOut },
            '-=' + randomDuration
        );
        timeline.eventCallback('onComplete', () => {
            rect.destroy();
        });
    }
}
